var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "acea-row row-middle" }, [
    _c(
      "div",
      { staticClass: "demo-image__preview line-heightOne mr5" },
      [
        _c("el-image", {
          staticClass: "el-image",
          attrs: {
            src: _vm.row.avatar,
            "preview-src-list": [_vm.row.avatar],
            fit: "cover",
          },
        }),
      ],
      1
    ),
    _c("span", { staticClass: "mr5", class: _vm.row.isLogoff ? "red" : "" }, [
      _vm._v(_vm._s(_vm.row.nickname || "--")),
    ]),
    _c("span", { staticClass: "red" }, [
      _vm._v(" | " + _vm._s(_vm.row.uid) + " | "),
    ]),
    _c("img", {
      staticClass: "sexImg",
      attrs: {
        src: _vm.getSexImage(_vm.row.sex),
        title: _vm.sexFilter(_vm.row.sex),
      },
    }),
    _vm.row.isLogoff
      ? _c("span", { staticClass: "red" }, [_vm._v(" | (已注销)")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }